import { useTranslation } from 'react-i18next';
import { PageHeader } from '../components/ui/PageHeader';

/**
 * Placeholder for Part F screens that need an infra dependency (PDF gen, OCR, etc.).
 * Lets the navigation routes resolve so users see the full menu structure today.
 *
 * Takes an i18n key rather than literal copy, so a placeholder screen reads in the operator's
 * language like every other screen. The copy lives under `stubs.<k>` in both catalogues.
 */
export default function Stub({ k }: { k: string }) {
  const { t } = useTranslation();
  const planned = t(`stubs.${k}.planned`, { defaultValue: '' });
  return (
    <div className="space-y-3">
      <PageHeader title={t(`stubs.${k}.title`)} description={t(`stubs.${k}.explain`)} />
      {planned && (
        <p className="text-xs text-muted-foreground italic">
          {t('stubs.planned', { what: planned })}
        </p>
      )}
    </div>
  );
}
